import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SPKRestService } from "../spk-rest.service";
import Swal from "sweetalert2";
import { SPKListComponent } from "../list/spk-list.component";
import { CommonService } from "../../../libraries/libraries.module";

@Component({
  selector: 'app-chassis-number-modal',
  templateUrl: 'chassis-number-modal.component.html',
  styleUrls: ['../spk-component.scss']
})
export class ChassisNumberModalComponent {
  @Input() spk: any;

  constructor(
    private _SPKRest: SPKRestService,
    public _spkListComponent: SPKListComponent
  ) {
    this.initFormChassisNumber();
  }

  isLoading: boolean = false;
  formUpdateChassisNumber: FormGroup;
  isChassisNumberModalOpen: boolean = false;

  initFormChassisNumber() {
    this.formUpdateChassisNumber = new FormGroup({
      chassisNumber: new FormControl('', [Validators.required])
    });
  }

  openChassisNumberModal() {
    if (['expired', 'rejected'].includes(this.spk.status)) return;
    this.formUpdateChassisNumber.patchValue({ chassisNumber: this.spk?.chassisNumber });
    this.isChassisNumberModalOpen = true;
  }

  closeChassisNumberModal() {
    this.isChassisNumberModalOpen = false;
    this.formUpdateChassisNumber.reset();
  }

  async updateChassisNumber() {
    if (!this.formUpdateChassisNumber.valid) {
      CommonService.markAsDirty(this.formUpdateChassisNumber);
    } else {
      const payload = {
        ...this.formUpdateChassisNumber.value,
        spkId: this.spk._id
      };
      this.isLoading = true;

      await this._SPKRest
        .updateChassisNumber(payload)
        .toPromise()
        .then(response => {
          if (response) {
            Swal.fire(
              'Update chassis number successfully!',
              '',
              'success'
            )

            this._spkListComponent.callHookDirectly('init');
            this.closeChassisNumberModal();
          }
        })
        .catch(error => {
          console.log(error)
          Swal.fire(
            'Oops..',
            'Something went wrong!',
            'error'
          )
        });
      this.isLoading = false;
    }
  }
}